{
	"gdprInfo1": "Marketing consent",
	"gdprInfo2": "By signing up to this mailing list you agree to that Iceland Post can use your information to send customized offers and other marketing material based on this information.",
	"gdprInfo3": "You can unsubscribe and update your information at any time by clicking the link in the footer of our e-mails or by sending an e-mail to postur@postur.is. More details about the privacy terms ",
	"gdprInfo3Link": "here.",
	"gdpr": "I agree to these terms and Iceland Post’s privacy policy."
}
